import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import './OrgAuth.css';

function OrgLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  async function onSubmit(data) {
    try {
      setError('');
      setLoading(true);

      const userCredential = await signInWithEmailAndPassword(
        auth,
        data.email,
        data.password
      );

      const user = userCredential.user;

      const orgDoc = await getDoc(doc(db, 'organizations', user.uid));

      if (!orgDoc.exists()) {
        await signOut(auth);
        setError('No organization account found with this email.');
        return;
      }

      
      
      const orgData = orgDoc.data();

      if (orgData.status === 'pending') {
        await signOut(auth);
        setError(
          'Your application is still under review. ' +
          'We will email you within 2-3 business days.'
        );
        return;
      }

      if (orgData.status === 'rejected') {
        await signOut(auth);
        setError(
          'Your application was not approved. ' +
          'Please contact us if you have questions.'
        );
        return;
      }

      if (orgData.status === 'suspended') {
        await signOut(auth);
        setError(
          'Your account has been suspended. ' +
          'Please contact us for more information.'
        );
        return;
      }

      navigate('/org/dashboard');

    } catch (err) {
      setError(getErrorMessage(err.code));
    } finally {
      setLoading(false);
    }
  }

  function getErrorMessage(code) {
    switch(code) {
      case 'auth/user-not-found':
      case 'auth/wrong-password':
      case 'auth/invalid-credential':
        return 'Invalid email or password.';
      case 'auth/too-many-requests':
        return 'Too many attempts. Please try again later.';
      default:
        return 'Something went wrong. Please try again.';
    }
  }

async function handlePasswordReset() {
  const email = window.prompt('Enter your email address:');
  if (!email) return;

  try {
    await sendPasswordResetEmail(auth, email);
    alert('Password reset email sent.');
  } catch (err) {
    console.error(err);
    alert('Could not send password reset email.');
  }
}

  return (
    <div className="auth-page org-auth-page">
      <div className="auth-card">

        <div className="auth-logo" onClick={() => navigate('/org')}>
          somebody.gives
        </div>

        <h1>Organization sign in</h1>
        <p className="auth-sub">
          Manage your needs and see what is on the way.
        </p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit(onSubmit)} className="auth-form">

          <div className="form-group">
            <label>Email address</label>
            <input
              {...register('email', {
                required: 'Email is required',
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Please enter a valid email'
                }
              })}
              placeholder="contact@yourorg.org"
              type="email"
            />
            {errors.email &&
              <span className="field-error">{errors.email.message}</span>}
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              {...register('password', {
                required: 'Password is required'
              })}
              placeholder="Your password"
              type="password"
            />
            {errors.password &&
              <span className="field-error">{errors.password.message}</span>}
          </div>

          <button
            type="submit"
            className="btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in →'}
          </button>

        </form>
<div className="auth-footer" style={{ marginTop: '0.5rem' }}>
  Forgot password?{' '}
  <span onClick={handlePasswordReset}>
    Reset it here
  </span>
</div>

        <div className="auth-footer">
          Not yet approved?{' '}
          <span onClick={() => navigate('/org/signup')}>
            Apply to join
          </span>
        </div>

        <div className="auth-footer" style={{ marginTop: '0.5rem' }}>
          Are you a donor?{' '}
          <span onClick={() => navigate('/give/login')}>
            Sign in here
          </span>
        </div>

      </div>
    </div>
  );
}

export default OrgLogin;